// Projects.jsx
import { projectsData } from "./Data";
import ParallaxGrowProjects from "./ParallaxGrowProjects";
import "./projects.css";

const Work = () => {
  const projects = projectsData.map((p) => ({
    id: p.id,
    slug: p.slug,
    title: p.title,
    subtitle: p.summary,
    videoSrc: p.video,        // optional
    bgSrc: p.cover,                    // fallback to cover image
    coverSrc: p.image,
  }));

  return (
    <section className="work section" id="projects">
      <h2 className="section__title">Projects</h2>
      <span className="section__subtitle">My Recent Work</span>
      <ParallaxGrowProjects projects={projects} />
    </section>
  );
};

export default Work;
